import { useEffect } from 'react';
import usePostMessage from 'hooks/utils/usePostMessage';
import { getParentUrl, isHylyghtAppAgent } from 'utils/browser';

const MobileAuth = () => {
  const { sendMessage, addEventListener, removeEventListener } =
    usePostMessage();

  useEffect(() => {
    if (isHylyghtAppAgent()) {
      addEventListener();
      sendNotAuthorized();
      return () => {
        removeEventListener();
      };
    }
  }, []);

  const sendNotAuthorized = () => {
    const data = {
      subject: 'unauthorized'
    };
    sendMessage({ message: data });
  };
};

export default MobileAuth;
